export var APP_EVENT_TOKEN_EXPIRED = 'tokenExpired';
export var UNIQUE_CUSTOMER_ELEMENT_ID = 'unique-customer-id';